// Animation duration from css (ms)
export const FIELD_ANIMATION_DURATION = 300;
